import React, { useState } from 'react';
import { LinkedinIcon } from 'lucide-react';
import { IframeModal } from './IframeModal';
export function Footer() {
  const [modal, setModal] = useState<{
    url: string;
    title: string;
  } | null>(null);
  const linkClasses = 'text-[#555555] hover:text-[#CC0000] transition-colors focus:outline-none focus:text-[#CC0000]';
  return <>
      <footer className="bg-[#f5f5f5] border-t border-gray-200 py-10 px-4 sm:px-6 lg:px-8" data-id="element-4">
        <div className="max-w-7xl mx-auto flex flex-col gap-8" data-id="element-5">
          <div className="flex flex-col md:flex-row justify-between gap-8" data-id="element-6">
            <div className="flex flex-col gap-2" data-id="element-7">
              <h3 className="text-sm font-semibold text-[#333333] uppercase tracking-wide" data-id="element-8">
                Sobre Zumpago
              </h3>
              <a href="https://zumpago.com/" target="_blank" rel="noopener noreferrer" className={`${linkClasses} text-sm font-medium`} data-id="element-9">
                Ir a Sitio Corporativo →
              </a>
            </div>

            <div className="flex flex-col gap-2" data-id="element-10">
              <h3 className="text-sm font-semibold text-[#333333] uppercase tracking-wide" data-id="element-11">
                Accesos a Plataformas
              </h3>
              <a href="#" className={`${linkClasses} text-sm font-medium`} data-id="element-12">
                Portal de Empresas e Instituciones
              </a>
            </div>

            <div className="flex flex-col gap-4" data-id="element-13">
              <h3 className="text-sm font-semibold text-[#333333] uppercase tracking-wide" data-id="element-14">
                Contacto
              </h3>
              <div className="flex flex-col gap-3 text-sm" data-id="element-15">
                <div data-id="element-16">
                  <p className="font-medium text-[#333333]" data-id="element-17">
                    Ventas y Comercial
                  </p>
                  <a href="mailto:ventas@zumpago.com" className={`${linkClasses} font-medium`} data-id="element-18">
                    ventas@zumpago.com
                  </a>
                </div>
                <div data-id="element-19">
                  <p className="font-medium text-[#333333]" data-id="element-20">
                    Consultas y Atención al Cliente
                  </p>
                  <a href="mailto:contacto@zumpago.com" className={`${linkClasses} font-medium`} data-id="element-21">
                    contacto@zumpago.com
                  </a>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-2" data-id="element-22">
              <h3 className="text-sm font-semibold text-[#333333] uppercase tracking-wide" data-id="element-23">
                Legal
              </h3>
              <div className="flex flex-col sm:flex-row gap-x-8 gap-y-2 text-sm font-medium" data-id="element-24">
                <button onClick={() => setModal({
                url: 'https://zumpago.com/privacidad',
                title: 'Políticas de Privacidad'
              })} className={`${linkClasses} cursor-pointer text-left`} data-id="element-25">
                  Políticas de Privacidad
                </button>
                <button onClick={() => setModal({
                url: 'https://zumpago.com/condiciones',
                title: 'Condiciones de Venta'
              })} className={`${linkClasses} cursor-pointer text-left`} data-id="element-26">
                  Condiciones de Venta
                </button>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-27">
            <p className="text-sm text-[#777777]" data-id="element-28">
              © {new Date().getFullYear()} Zumpago Argentina. Todos los
              derechos reservados.
            </p>
            <a href="https://www.linkedin.com/company/zumpago/" target="_blank" rel="noopener noreferrer" aria-label="Zumpago en LinkedIn" className="text-[#555555] hover:text-[#0A66C2] transition-colors" data-id="element-29">
              <LinkedinIcon className="w-5 h-5" data-id="element-30" />
            </a>
          </div>
        </div>
      </footer>

      {modal && <IframeModal url={modal.url} title={modal.title} onClose={() => setModal(null)} data-id="element-31" />}
    </>;
}